import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trophy } from "lucide-react";

const DASH = { "/app/dashboard": ["", "Semua tim"], "/app/design-dashboard": ["design", "Tim Design"], "/app/production-dashboard": ["production", "Tim Produksi"], "/app/finishing": ["finishing", "Tim Finishing"],
  "/app/qc": ["qc", "Tim QC"], "/app/dokumentasi": ["docs", "Tim Dokumentasi"], "/app/packing": ["production", "Tim Packing"], "/app/pengiriman": ["shipping", "Tim Pengiriman"], "/app/sales": ["sales", "Tim Sales"] };

export const ScoreStrip = ({ path }) => {
  const cfg = DASH[path]; const [d, setD] = useState(null);
  useEffect(() => {
    if (!cfg) { setD(null); return undefined; }
    const load = () => api.get("/scoreboard", { params: { team: cfg[0] } }).then(({ data }) => setD(data)).catch(() => setD(null));
    load(); const t = setInterval(load, 300000);
    return () => clearInterval(t);
  }, [path]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!cfg || !d || (!d.me && !d.team.length)) return null;
  return (
    <div className="mb-4 rounded-xl border border-slate-200 bg-white px-4 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-sm" data-testid="score-strip">
      <span className="inline-flex items-center gap-1.5 font-semibold text-slate-700"><Trophy className="w-4 h-4 text-amber-500" />Skor kinerja {d.month}</span>
      {d.me && <span data-testid="score-me" className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${d.me.low ? "bg-rose-100 text-rose-700" : "bg-emerald-100 text-emerald-700"}`}>Nilai saya {d.me.perf}{d.me.rank ? ` · peringkat ${d.me.rank}/${d.count}` : ""}</span>}
      <span className="text-xs text-slate-400">{cfg[1]}:</span>
      <div className="flex flex-wrap gap-1.5" data-testid="score-team">{d.team.slice(0, 6).map((r, i) => (
        <span key={r.employee_id} className={`text-xs px-2 py-0.5 rounded-full border ${r.low ? "border-rose-200 text-rose-600" : "border-slate-200 text-slate-600"}`}>{i + 1}. {r.name} <b>{r.perf}</b></span>))}</div>
    </div>
  );
};
